import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PLANS, money } from "../data/site";
import { Reveal } from "./motion";

export const PlanCards = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
    {Object.values(PLANS).map((p, i) => {
      const featured = p.key === "plus";
      return (
        <Reveal key={p.key} delay={i * 0.1}>
          <div
            data-testid={`plan-card-${p.key}`}
            className={`relative h-full flex flex-col rounded-2xl border p-7 transition-transform duration-300 hover:-translate-y-1 ${
              featured
                ? "border-emerald-600 bg-slate-950 text-white shadow-[0_30px_60px_-20px_rgba(5,150,105,0.35)]"
                : "border-slate-200 bg-white"
            }`}
          >
            {featured && (
              <span className="absolute -top-3 left-7 rounded-full bg-emerald-600 text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1">
                Most popular
              </span>
            )}
            <h3 className={`font-display text-xl font-extrabold ${featured ? "text-white" : "text-slate-900"}`}>{p.name}</h3>
            <p className={`mt-1 text-sm ${featured ? "text-slate-300" : "text-slate-500"}`}>{p.fit}</p>
            <div className="mt-5 flex items-baseline gap-1">
              <span className={`font-mono-num text-4xl font-bold ${featured ? "text-emerald-400" : "text-slate-900"}`}>{money(p.base)}</span>
              <span className={featured ? "text-slate-400" : "text-slate-500"}>/month</span>
            </div>
            <p className={`text-sm ${featured ? "text-slate-300" : "text-slate-600"}`}>+ {money(p.per)} per person paid</p>
            <p className={`mt-2 text-xs ${featured ? "text-slate-400" : "text-slate-400"}`}>
              {p.cname}: {money(p.cbase)}/month + {money(p.cper)} per person
            </p>
            <Link
              to={`/contact?plan=${p.key}`}
              data-testid={`plan-cta-${p.key}`}
              className={`mt-6 inline-flex justify-center rounded-full px-5 py-3 text-sm font-bold transition-colors ${
                featured ? "bg-emerald-600 text-white hover:bg-emerald-500" : "bg-slate-900 text-white hover:bg-emerald-700"
              }`}
            >
              Start with {p.name}
            </Link>
            <ul className={`mt-6 space-y-2.5 text-sm ${featured ? "text-slate-200" : "text-slate-600"}`}>
              {p.features.map((f) => (
                <li key={f} className="flex gap-2.5">
                  <Check size={16} className="mt-0.5 shrink-0 text-emerald-500" />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      );
    })}
  </div>
);
